import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
   return (
      <div style={{ padding: '6rem 2rem', maxWidth: '600px', margin: '0 auto', textAlign: 'center', color: 'white', fontFamily: 'sans-serif' }}>
         <h1 style={{ fontSize: '5rem', color: '#ef4444', margin: '0 0 1rem 0', fontWeight: 800, textShadow: '0 0 20px rgba(239,68,68,0.4)' }}>404</h1>
         <h2 style={{ marginBottom: '1.5rem', fontSize: '2rem', fontWeight: 600 }}>Dead End / Missing Route</h2>
         <p style={{ color: 'var(--text-muted)', marginBottom: '3rem', lineHeight: '1.6', fontSize: '1.1rem' }}>
            The requested destination path does not map to any known layout or API proxy within the dark.tel infrastructure matrix. It may have been structurally deleted or you typed an invalid URI.
         </p>
         <Link 
            to="/" 
            style={{ display: 'inline-block', padding: '1rem 2.5rem', background: 'var(--primary)', color: 'white', textDecoration: 'none', borderRadius: '4px', fontWeight: 600, fontSize: '1.1rem', boxShadow: '0 4px 15px rgba(96, 165, 250, 0.4)' }}
         >
            {window.location.hostname === 'crm.dark.tel' ? 'Return to Login' : 'Return to Core Dashboard'}
         </Link>
      </div>
   );
}
